import { useEffect } from "react";
import { useHistory } from "react-router-dom";

// 페이지 변경 시 scroll 최상단으로 올려주는 hook
export const useScrollTopRefresher = () => {
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });

    return () => unlisten();
  }, [history]);

  return null;
};
